import {appendQueryString} from "@pg-mono/request";

import {Planner3DDefinitions} from "../../../constants/get_planner_3d_data";
import {YslabProperty} from "./api/yslab_investments_api";

export const getYslabPropertyUrl = (plannerData: Planner3DDefinitions, yslabProperty: YslabProperty) => {
    const appOptions = {
        ...plannerData.defaultOptions,
        ...(yslabProperty && {app: 1, a: yslabProperty.name})
    };

    if (yslabProperty && plannerData.plannerUrl) {
        return appendQueryString(plannerData.plannerUrl, appOptions);
    }
};
import {appendQueryString} from "@pg-mono/request";

import {Planner3DDefinitions} from "../../../constants/get_planner_3d_data";
import {YslabProperty} from "./api/yslab_investments_api";

export const getYslabPropertyUrl = (plannerData: Planner3DDefinitions, yslabProperty: YslabProperty) => {
    const appOptions = {
        ...plannerData.defaultOptions,
        ...(yslabProperty && {app: 1, a: yslabProperty.name})
    };

    if (yslabProperty && plannerData.plannerUrl) {
        return appendQueryString(plannerData.plannerUrl, appOptions);
    }
};
